import {
    POST_ORDER_CREATE_REQUEST,
    POST_ORDER_CREATE_SUCCESS,
    POST_ORDER_CREATE_FAILURE,
    CHANGE_EDIT_STATE,
} from '../mutationTypes';

const state = {
    loading: false,
    userCardList: [],
    cardLoading: false,
    canEdit: false, // 是否可编辑
};
const mutations = {
    [POST_ORDER_CREATE_REQUEST](state) {
        state.loading = true;
    },
    [POST_ORDER_CREATE_SUCCESS](state) {
        state.loading = false;
    },
    [POST_ORDER_CREATE_FAILURE](state) {
        state.loading = false;
    },
    [CHANGE_EDIT_STATE](state, val) {
        state.canEdit = val;
    },
};

// export const actions = {
//     async confirmOrder({ commit }, orderData) {
//         commit(POST_ORDER_CREATE_REQUEST);
//         let apiName = '';
//         const { orderState } = orderData;
//         if (orderState === 0) {
//             apiName = 'recordOrder';
//         } else if (orderState === 1) {
//             apiName = 'finishOrder';
//         } else {
//             apiName = 'cancelOrder';
//         }

//         const res = await Vue.$ajax.post(apiName, orderData);

//         // 1.5 爱车卡核销可能被占用, 所以需要返回, 查看是否返回 data.fail_list
//         if (!res.errorType) {
//             commit(POST_ORDER_CREATE_SUCCESS);
//             return Object.assign({}, res, {
//                 success: true,
//             });
//         }
//         commit(POST_ORDER_CREATE_FAILURE);
//         return Object.assign({}, res, {
//             success: false,
//         });
//     },
// };

export default {
    state,
    mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/editOrder.js